module.exports = __webpack_public_path__ + "fonts/Agency_FB_Bold.f0d9cc32.ttf";